/**
 * Pinterest tag helpers
 * Wraps window.pintrk with type safety and unique event IDs.
 */

declare global {
  interface Window {
    pintrk?: (...args: unknown[]) => void;
  }
}

function pintrk(...args: unknown[]) {
  if (typeof window !== 'undefined' && typeof window.pintrk === 'function') {
    window.pintrk(...args);
  }
}

function uniqueId(prefix: string) {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
}

export function trackViewCategory() {
  pintrk('track', 'viewcategory', {
    event_id: uniqueId('vc'),
  });
}


export function trackSearch(searchQuery: string) {
  pintrk('track', 'search', {
    event_id: uniqueId('srch'),
    search_query: searchQuery,
  });
}


export function trackCustom(eventName: string, data?: Record<string, unknown>) {
  pintrk('track', eventName, {
    event_id: uniqueId('custom'),
    ...data,
  });
}


export function trackWatchVideo(videoTitle: string) {
  pintrk('track', 'watchvideo', {
    event_id: uniqueId('wv'),
    video_title: videoTitle,
  });
}

export function trackLead(leadType: string) {
  pintrk('track', 'lead', {
    event_id: uniqueId('lead'),
    lead_type: leadType,
  });
}

export function trackSignup() {
  pintrk('track', 'signup', {
    event_id: uniqueId('signup'),
  });
}
